import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { isAuthenticated, getAuthUser } from '../utils/auth';
import Sidebar from './Sidebar';
import './Layout.css';

const Layout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const navigate = useNavigate();

  // Check authentication
  useEffect(() => {
    if (!isAuthenticated()) {
      navigate('/');
    }
  }, [navigate]);

  if (!isAuthenticated()) {
    return null;
  }

  const adminUser = getAuthUser();

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  // Close sidebar when clicking outside on mobile
  const handleMainContentClick = () => {
    if (window.innerWidth <= 768 && sidebarOpen) {
      setSidebarOpen(false);
    }
  };

  return (
    <div className="layout">
      <Sidebar isOpen={sidebarOpen} onClose={closeSidebar} />
      
      <div 
        className={`main-content ${sidebarOpen ? 'sidebar-open' : ''}`}
        onClick={handleMainContentClick}
      >
        <header className="main-header">
          <div className="header-left">
            <button className="mobile-menu-btn" onClick={toggleSidebar}>
              ☰
            </button>
            <button className="desktop-toggle-btn" onClick={toggleSidebar}>
              ☰
            </button>
            <div className="header-info">
              <h1 className="header-title">RpoMeds Admin</h1>
              <p className="header-subtitle">Welcome back, {adminUser?.email}</p>
            </div>
          </div>
        </header>
        
        <main className="main-body">
          {children}
        </main>
      </div>
    </div>
  );
};

export default Layout; 